import React from 'react'
import { INK, MUTED } from '../core/consts'

/** One labelled value in a card's facts row: an uppercase caption over the value. */
export const Fact: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <div className='d-flex flex-column' style={{ gap: 3 }}>
    <div style={{ fontSize: 11.5, color: MUTED, textTransform: 'uppercase' }}>{label}</div>
    <div style={{ fontSize: 13, fontWeight: 500, color: INK }}>{value}</div>
  </div>
)

export default Fact
